import { useState } from 'react'

import { Space } from 'app/common/templates-next/report-template'

import { Filters } from './filters'
import { Result } from './result'

type Props = {
  profileLink: string
}

export const FinancesSummary = ({ profileLink }: Props) => {
  const [reportId, setReportId] = useState<null | string>(null)

  return (
    <>
      <Filters onReportId={setReportId} profileLink={profileLink} />
      <Space />
      <Result reportId={reportId} onReportId={setReportId} />
    </>
  )
}
